/* eslint-disable */
import React, { useState, useEffect } from 'react';
import * as Yup from 'yup';
import { useFormik, Form, FormikProvider } from 'formik'
import { useNavigate, useParams } from 'react-router-dom';
import {
    Container, Stack, TextField, ButtonGroup, Grid,
    MenuItem, Typography, Card, IconButton, Tooltip
} from '@material-ui/core';
import { LoadingButton } from '@material-ui/lab';
import Divider from '@material-ui/core/Divider';
import Page from '../../../../Page';
import { ToastContainer, toast } from 'react-toastify';
import ArrowForwardIosOutlinedIcon from '@material-ui/icons/ArrowForwardIosOutlined';
import ArrowBackIosOutlinedIcon from '@material-ui/icons/ArrowBackIosOutlined';
import services from '../../Service';
import TableContainer from '@material-ui/core/TableContainer';
import Table from '@material-ui/core/Table';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import TableBody from '@material-ui/core/TableBody';
import DeleteIcon from '@material-ui/icons/Delete';
import Paper from '@material-ui/core/Paper';
import TokenDecoder from 'src/helpers/TokenDecoder';
import { trackPromise } from 'react-promise-tracker';
import { LoadingComponent } from 'src/pages/pageLoader';
import { AlertDialog } from './../../../Common/AlertDialog';
import EditIcon from '@material-ui/icons/Edit';


export function Farming({ handleNext, handleBack, farmerId }) {
    const navigate = useNavigate();
    const [message, setMessage] = useState("Delete Confirmation");
    const [EnableConfirmMessage, setEnableConfirmMessage] = useState(false);
    const [enableOther, setEnableOther] = useState(false);
    const [farmerFarmingDetailID, setFarmerFarmingDetailID] = useState();
    const [familyArray, setFamilyArray] = useState([]);
    const [farmingChild, setFarmingChild] = useState([]);
    const [farmingMaster, setFarmingMaster] = useState([]);
    const [dataGrid, setDataGrid] = useState([]);
    const [factoryType, setFactoryType] = useState(0);
    const [allDisableButton, setAllDisableButton] = useState(false);
    const [formData, setFormData] = useState({

        TypesOfCrops: '0',
        OtherTypesOfCrops: '',
        TypesOfField: '0',
        OtherTypesOfField: '',
        CultivateLandExtent: '0',
        Value: '',
        FarmingPractice: '0',
        OtherFarmingPractice: '',
        FarmingSystem: '0',
        TeachnologyUsed: '0',
        OtherTeachnologyUsed: '',
        DateOfFirstInstallation: '',
        FieldIrrigationMethod: '0',
        OtherFieldIrrigationMethod: '',
        WaterSource: '0',
        OtherWaterSource: '',
        //LabourType: '0',
        OtherLabourType: '',
        farmerID: 0,
        farmingMasterID: 0,
        farmingChildID: 0,
        farmingChildName: '',
        other: '',
    });
    const [pageProps, setPageProps] = useState({
        editingID: 0,
        Edit: false,
        submitButtonName: "Add",
        pageheadername: "Add Supplier Details "
    });
    const FarmingSaveSchema = Yup.object().shape({
        TypesOfCrops: Yup.number().min(1, 'Please Select Crops Cultivated').required('Crops Cultivated Required'),
        OtherTypesOfCrops: Yup.string().when('TypesOfCrops', { is: (TypesOfCrops) => TypesOfCrops == 4, then: Yup.string().required('Other Crops Cultivated is Required'), otherwise: Yup.string().nullable(), }),
        TypesOfField: Yup.number().min(1, 'Please Select Field Type').required('Field Type Required'),
        OtherTypesOfField: Yup.string().when('TypesOfField', { is: (TypesOfField) => TypesOfField == 3, then: Yup.string().required('Other Field Type is Required'), otherwise: Yup.string().nullable(), }),
        CultivateLandExtent: Yup.number().min(1, 'Please Select Cultivatable Land Extent ').required('Cultivatable Land Extent Required'),
        Value: Yup.number().min(0.01, 'Value Required').required('Value Required'),
        FarmingPractice: Yup.number().min(1, 'Please Select Farming Practice ').required('Farming Practice Required'),
        OtherFarmingPractice: Yup.string().when('FarmingPractice', { is: (FarmingPractice) => FarmingPractice == 5, then: Yup.string().required('Other Farming Practice is Required'), otherwise: Yup.string().nullable(), }),
        FarmingSystem: Yup.number().min(1, 'Please Select Farming System').required('Farming System Required'),
        TeachnologyUsed: Yup.number().min(1, 'Please Select Technologies Used').required('Technologies Used Required'),
        OtherTeachnologyUsed: Yup.string().when('TeachnologyUsed', { is: (TeachnologyUsed) => TeachnologyUsed == 4, then: Yup.string().required('Other Technologies Used is Required'), otherwise: Yup.string().nullable(), }),
        DateOfFirstInstallation: Yup.string().required('Date Of First Installation Required'),
        FieldIrrigationMethod: Yup.number().min(1, 'Please select Field  IrrigationMethod').required('Field Irrigation Method Required'),
        OtherFieldIrrigationMethod: Yup.string().when('FieldIrrigationMethod', { is: (FieldIrrigationMethod) => FieldIrrigationMethod == 4, then: Yup.string().required('Other Field Irrigation Method is Required'), otherwise: Yup.string().nullable(), }),
        WaterSource: Yup.number().min(1, 'Please Select Water Source').required('Water Source Required'),
        OtherWaterSource: Yup.string().when('WaterSource', { is: (WaterSource) => WaterSource == 4, then: Yup.string().required('Other Water Source is Required'), otherwise: Yup.string().nullable(), }),
        //LabourType: Yup.number().min(1, 'Please Select Labour Used').required('Labour Used Required'),
        //OtherLabourType: Yup.string().when('LabourType', { is: (LabourType) => LabourType == 4, then: Yup.string().required('Other Labour Used is Required'), otherwise: Yup.string().nullable(), }),
        //farmingMasterID: Yup.number().min(1, 'Please Select Farming Master Type').required('Farming Master Type Required'),
        //farmingChildID: Yup.number().min(1, 'Please Select Farming Sub Type').required('Farming Sub Type Required'),
        //other: Yup.string().when('farmingChildName', { is: (farmingChildName) => farmingChildName == "Other", then: Yup.string().required('Other Required').matches(/^[^0-9\s].*[^0-9\s]$/, 'Field should not contain only symbols or numbers'), otherwise: Yup.string().nullable(), }),
    });


    const formik = useFormik({
        initialValues: {
            TypesOfCrops: formData.TypesOfCrops,
            OtherTypesOfCrops: formData.OtherTypesOfCrops,
            TypesOfField: formData.TypesOfField,
            OtherTypesOfField: formData.OtherTypesOfField,
            CultivateLandExtent: formData.CultivateLandExtent,
            Value: formData.Value,
            FarmingPractice: formData.FarmingPractice,
            OtherFarmingPractice: formData.OtherFarmingPractice,
            FarmingSystem: formData.FarmingSystem,
            TeachnologyUsed: formData.TeachnologyUsed,
            OtherTeachnologyUsed: formData.OtherTeachnologyUsed,
            DateOfFirstInstallation: formData.DateOfFirstInstallation,
            FieldIrrigationMethod: formData.FieldIrrigationMethod,
            OtherFieldIrrigationMethod: formData.OtherFieldIrrigationMethod,
            WaterSource: formData.WaterSource,
            OtherWaterSource: formData.OtherWaterSource,
            //LabourType: formData.LabourType,
            //OtherLabourType: formData.OtherLabourType,
            farmerID: farmerId,
            //farmingMasterID: formData.farmingMasterID,
            //farmingChildID: formData.farmingChildID,
            //farmingChildName: formData.farmingChildName,
            //other: formData.other
        },

        validationSchema: FarmingSaveSchema,

        onSubmit: (values) => {

            addGrid(values);

        },

        enableReinitialize: true

    });
    const { errors, setValues, touched, handleSubmit, isSubmitting, getFieldProps, values } = formik;

    useEffect(() => {
        trackPromise(getAllFarmingMasterDetails());
        trackPromise(GetFarmingDetailsbyFarmerID(farmerId));
        GetSupplierTypeIDbyFarmerID(farmerId);
    }, []);

    useEffect(() => {
        getAllFarmingChildDetailsByFarmingMasterID(formik.values.farmingMasterID);
    }, [formik.values.farmingMasterID]);

    useEffect(() => {
        ClearArea()
    }, [formik.values.farmingChildID]);

    useEffect(() => {
        setValues({
            ...values,
            other: " "
        })
    }, [formik.values.farmingChildID, formik.values.farmingMasterID]);

    async function GetSupplierTypeIDbyFarmerID(farmerId) {
        const res = await services.GetSupplierTypeIDbyFarmerID(farmerId)
        if (res == 2) {
            setAllDisableButton(true)
        }
        else {
            setAllDisableButton(false)
        }
        setDataGrid(res)
    }
    async function GetFarmingDetailsbyFarmerID(farmerId) {
        const res = await services.GetFarmingDetailsbyFarmerID(farmerId)
        setDataGrid(res)
    }

    async function getAllFarmingMasterDetails() {
        const data = await services.GetAllFarmingMasterDetails();
        if (data != null) {
            setFarmingMaster(data);
        }
        setFactoryType(parseInt(TokenDecoder.getFactoryTypeFromToken()))
    }

    async function getAllFarmingChildDetailsByFarmingMasterID(farmingMasterID) {
        const data = await services.GetAllFarmingChildDetailsByFarmingMasterID(farmingMasterID);
        if (data != null) {
            setFarmingChild(data);
        }
    }

    async function ClearArea() {
        if (pageProps.Edit == false) {
            var result = farmingChild.find(x => x.farmingChildID == formik.values.farmingChildID)
            if (result == undefined || result.farmingChildName != 'Other') {
                setEnableOther(false)
            }
            else {
                setEnableOther(true)
            }
            setValues({
                ...values,
                other: ''
            })
        }

    }

    async function addGrid(values) {
        if (pageProps.Edit != true) {
            var modelOne = {
                typesOfCrops: parseInt(values.TypesOfCrops),
                otherTypesOfCrops: values.OtherTypesOfCrops.trim(),
                typesOfField: parseInt(values.TypesOfField),
                otherTypesOfField: values.OtherTypesOfField.trim(),
                cultivateLandExtent: parseInt(values.CultivateLandExtent),
                value: parseFloat(values.Value),
                farmingPractice: parseInt(values.FarmingPractice),
                otherfarmingPractice: values.OtherFarmingPractice.trim(),
                farmingSystem: parseInt(values.FarmingSystem),
                teachnologyUsed: parseInt(values.TeachnologyUsed),
                otherteachnologyUsed: values.OtherTeachnologyUsed.trim(),
                dateOfFirstInstallation: values.DateOfFirstInstallation == "" ? null : values.DateOfFirstInstallation,
                fieldIrrigationMethod: parseInt(values.FieldIrrigationMethod),
                otherfieldIrrigationMethod: values.OtherFieldIrrigationMethod.trim(),
                waterSource: parseInt(values.WaterSource),
                otherWaterSource: values.OtherWaterSource.trim(),
                labourType: parseInt(0),
                otherLabourType: "",
                farmerID: parseInt(values.farmerID),
                // farmingMasterID: parseInt(values.farmingMasterID),
                // farmingChildID: parseInt(values.farmingChildID),
                // farmingChildName: parseInt(values.farmingChildName),
                // other: values.other,
                createdBy: parseInt(TokenDecoder.getUserIDFromToken())
            }

            const res = await services.SaveFarmingDetails(modelOne);
            if (res > 0) {
                toast.success("Farming Details Saved Succesfully");
                trackPromise(GetFarmingDetailsbyFarmerID(farmerId));
                clearAll();
            } else {
                toast.error("Error occured in Farming Details");
            }
        }
        else {

            var modelOne = {

                typesOfCrops: parseInt(values.TypesOfCrops),
                otherTypesOfCrops: values.OtherTypesOfCrops,
                typesOfField: parseInt(values.TypesOfField),
                otherTypesOfField: values.OtherTypesOfField,
                cultivateLandExtent: parseInt(values.CultivateLandExtent),
                value: parseFloat(values.Value),
                farmingPractice: parseInt(values.FarmingPractice),
                otherFarmingPractice: values.OtherFarmingPractice,
                farmingSystem: parseInt(values.FarmingSystem),
                teachnologyUsed: parseInt(values.TeachnologyUsed),
                otherTeachnologyUsed: values.OtherTeachnologyUsed,
                //dateOfFirstInstallation: values.DateOfFirstInstallation,
                dateOfFirstInstallation: values.DateOfFirstInstallation == "" ? null : values.DateOfFirstInstallation,
                fieldIrrigationMethod: parseInt(values.FieldIrrigationMethod),
                otherFieldIrrigationMethod: values.OtherFieldIrrigationMethod,
                waterSource: parseInt(values.WaterSource),
                otherWaterSource: values.OtherWaterSource,
                labourType: parseInt(0),
                otherLabourType: "",
                farmerID: parseInt(values.farmerID),
                farmerFarmingDetailID: parseInt(pageProps.editingID),
                // farmingMasterID: parseInt(values.farmingMasterID),
                // farmingChildID: parseInt(values.farmingChildID),
                // farmingChildName: parseInt(values.farmingChildName),
                // other: values.other,
                createdBy: parseInt(TokenDecoder.getUserIDFromToken())
            }
            const res = await services.UpdateFarmingDetails(modelOne);
            if (res.statusCode == 'Success') {
                toast.success("Farming Details Updated Succesfully");
                trackPromise(GetFarmingDetailsbyFarmerID(farmerId));
                setPageProps({
                    ...pageProps,
                    editingID: 0,
                    Edit: false,
                    submitButtonName: "Add",
                })
                clearAll();
            } else {
                toast.error("Error occured in Farmer Farming Details.");
            }
        }
    }

    async function clearAll() {
        formik.resetForm();
    }

    async function DeleteItem(data) {
        const res = await services.DeleteFarmingDetails(data);
        if (res > 0) {
            toast.success("Farming Details Deleted Succesfully");
            trackPromise(GetFarmingDetailsbyFarmerID(farmerId));
        } else {
            toast.error(res.message);
        }
    }

    function confirmData(y) {
        if (y) {
            DeleteItem(farmerFarmingDetailID);
        }
    }

    function handleConfirm(data) {
        setFarmerFarmingDetailID(data);
        setEnableConfirmMessage(true);
    }

    function handleEdit(rowData, index) {
        var array = [...dataGrid];
        if (rowData.farmingChildName == "Other") {
            setEnableOther(true);
        }
        else {
            setEnableOther(false);
        }

        setValues({
            ...values,
            TypesOfCrops: rowData.typesOfCrops,
            OtherTypesOfCrops: rowData.otherTypesOfCrops,
            TypesOfField: rowData.typesOfField,
            OtherTypesOfField: rowData.otherTypesOfField,
            CultivateLandExtent: rowData.cultivateLandExtent,
            Value: rowData.value,
            FarmingPractice: rowData.farmingPractice,
            OtherFarmingPractice: rowData.otherFarmingPractice,
            FarmingSystem: rowData.farmingSystem,
            TeachnologyUsed: rowData.teachnologyUsed,
            OtherTeachnologyUsed: rowData.otherTeachnologyUsed,
            DateOfFirstInstallation: rowData.dateOfFirstInstallation.split('T')[0],
            FieldIrrigationMethod: rowData.fieldIrrigationMethod,
            OtherFieldIrrigationMethod: rowData.otherFieldIrrigationMethod,
            WaterSource: rowData.waterSource,
            OtherWaterSource: rowData.otherWaterSource,
            //LabourType: rowData.labourType,
            //OtherLabourType: rowData.otherLabourType,
            // farmingMasterID: rowData.farmingMasterID,
            // farmingChildID: rowData.farmingChildID,
            // farmingChildName: rowData.farmingChildName,
            // other: rowData.other
        })
        array.splice(index, 1);
        setPageProps({
            ...pageProps,
            editingID: rowData.farmerFarmingDetailID,
            Edit: true,
            submitButtonName: "Update",
        })
        setDataGrid(array);
    }

    return (
        <>
            <LoadingComponent />
            <Page title="Farming details |  FAPS">
                <Container>
                    <FormikProvider value={formik}>
                        <ToastContainer
                            position="bottom-right"
                            pauseOnHover
                        />
                        <Form autoComplete="off"
                            disabled={!(formik.isValid && formik.dirty)}
                            noValidate onSubmit={handleSubmit}
                        >
                            <Card style={{ justifycontent: 'center' }} >
                                <Stack spacing={2} margin={3}>
                                    <Typography variant="h6">
                                        {(factoryType == 1 || factoryType == 3) ? "View Farming Details" : "Farming Details"}
                                        <Stack direction={{ xs: 'column', sm: 'row' }} justifyContent="right" >
                                            <ButtonGroup disableElevation variant="outlined" color="primary">
                                                <Tooltip title="Loan">
                                                    <IconButton
                                                        variant="outlined"
                                                        color="secondary"
                                                        onClick={handleBack}
                                                    >
                                                        <ArrowBackIosOutlinedIcon />
                                                    </IconButton>
                                                </Tooltip>
                                                <Tooltip title="Income & Assets">
                                                    <IconButton
                                                        variant="outlined"
                                                        color="secondary"
                                                        onClick={handleNext}
                                                    >
                                                        <ArrowForwardIosOutlinedIcon />
                                                    </IconButton>
                                                </Tooltip>
                                            </ButtonGroup>
                                        </Stack>
                                    </Typography>
                                    <Stack direction={{ xs: 'column', sm: 'row' }} style={{ marginTop: '25px' }} spacing={2}>

                                        <Stack width={340}>
                                            <TextField select
                                                fullWidth
                                                size="small"
                                                label="Crops Cultivated *"
                                                value={formik.values.TypesOfCrops}
                                                onChange={(event) => {
                                                    formik.handleChange(event);

                                                    // Check if the selected value is 'Other' to enable/disable the other text field
                                                    if (event.target.value === 4) {
                                                        formik.setFieldValue('OtherTypesOfCrops', '');
                                                    }
                                                }}
                                                {...getFieldProps('TypesOfCrops')}
                                                error={Boolean(touched.TypesOfCrops && errors.TypesOfCrops)}
                                                helperText={touched.TypesOfCrops && errors.TypesOfCrops}
                                                disabled={factoryType == 1 || factoryType == 3 || allDisableButton}
                                            >
                                                <MenuItem key={0} value={0}> Select Crops Cultivated</MenuItem>
                                                <MenuItem value={1}> Vegetable</MenuItem>
                                                <MenuItem value={2}> Fruits</MenuItem>
                                                <MenuItem value={3}> Paddy</MenuItem>
                                                <MenuItem value={4}> Other</MenuItem>
                                            </TextField>
                                        </Stack>
                                        <Stack width={340}>

                                            <TextField
                                                fullWidth
                                                size="small"
                                                label="Other Crops Cultivated *"
                                                value={formik.values.OtherTypesOfCrops}
                                                onChange={formik.handleChange}
                                                {...getFieldProps('OtherTypesOfCrops')}
                                                error={Boolean(touched.OtherTypesOfCrops && errors.OtherTypesOfCrops)}
                                                helperText={touched.OtherTypesOfCrops && errors.OtherTypesOfCrops}
                                                disabled={factoryType == 1 || factoryType == 3 || formik.values.TypesOfCrops !== 4 || allDisableButton}
                                            />

                                        </Stack>
                                        <Stack width={340}>
                                            <TextField select
                                                fullWidth
                                                size="small"
                                                label="Field Type *"
                                                value={formik.values.TypesOfField}
                                                onChange={(event) => {
                                                    formik.handleChange(event);

                                                    // Check if the selected value is 'Other' to enable/disable the other text field
                                                    if (event.target.value === 3) {
                                                        formik.setFieldValue('OtherTypesOfField', '');
                                                    }
                                                }}
                                                {...getFieldProps('TypesOfField')}
                                                error={Boolean(touched.TypesOfField && errors.TypesOfField)}
                                                helperText={touched.TypesOfField && errors.TypesOfField}
                                                disabled={factoryType == 1 || factoryType == 3 || allDisableButton}
                                            >
                                                <MenuItem key={0} value={0}> Select Field Type</MenuItem>
                                                <MenuItem value={1}> Open Field</MenuItem>
                                                <MenuItem value={2}> Poly Tunnel</MenuItem>
                                                <MenuItem value={3}> Other</MenuItem>
                                            </TextField>
                                        </Stack>
                                    </Stack >
                                    <Stack direction={{ xs: 'column', sm: 'row' }} style={{ marginTop: '25px' }} spacing={2}>
                                        <Stack width={340}>

                                            <TextField
                                                fullWidth
                                                size="small"
                                                label="Other Field Type *"
                                                value={formik.values.OtherTypesOfField}
                                                onChange={formik.handleChange}
                                                {...getFieldProps('OtherTypesOfField')}
                                                error={Boolean(touched.OtherTypesOfField && errors.OtherTypesOfField)}
                                                helperText={touched.OtherTypesOfField && errors.OtherTypesOfField}
                                                disabled={factoryType == 1 || factoryType == 3 || formik.values.TypesOfField !== 3 || allDisableButton}
                                            />

                                        </Stack>

                                        <Stack width={340}>
                                            <TextField select
                                                fullWidth
                                                size="small"
                                                label="Cultivatable Land Extent * "
                                                value={formik.values.CultivateLandExtent}
                                                onChange={formik.handleChange}
                                                {...getFieldProps('CultivateLandExtent')}
                                                error={Boolean(touched.CultivateLandExtent && errors.CultivateLandExtent)}
                                                helperText={touched.CultivateLandExtent && errors.CultivateLandExtent}
                                                disabled={factoryType == 1 || factoryType == 3 || allDisableButton}
                                            >
                                                <MenuItem key={0} value={0}> Select Cultivatable Land Extent</MenuItem>
                                                <MenuItem value={1}> Acres</MenuItem>
                                                <MenuItem value={2}> Perches</MenuItem>
                                                <MenuItem value={3}> Sq.ft</MenuItem>
                                            </TextField>
                                        </Stack>
                                        <Stack width={340}>
                                            <TextField
                                                fullWidth
                                                size="small"
                                                label="Value *"
                                                value={formik.values.Value}
                                                onChange={formik.handleChange}
                                                {...getFieldProps('Value')}
                                                error={Boolean(touched.Value && errors.Value)}
                                                helperText={touched.Value && errors.Value}
                                                disabled={factoryType == 1 || factoryType == 3 || allDisableButton}
                                                InputProps={{
                                                    step: 0.01,
                                                    type: 'number'
                                                }}
                                            />
                                        </Stack>
                                    </Stack>
                                    <Stack direction={{ xs: 'column', sm: 'row' }} style={{ marginTop: '25px' }} spacing={2}>
                                        <Stack width={340}>
                                            <TextField select
                                                fullWidth
                                                size="small"
                                                label="Farming Practice * "
                                                value={formik.values.FarmingPractice}
                                                onChange={(event) => {
                                                    formik.handleChange(event);

                                                    // Check if the selected value is 'Other' to enable/disable the other text field
                                                    if (event.target.value === 5) {
                                                        formik.setFieldValue('OtherFarmingPractice', '');
                                                    }
                                                }}
                                                {...getFieldProps('FarmingPractice')}
                                                error={Boolean(touched.FarmingPractice && errors.FarmingPractice)}
                                                helperText={touched.FarmingPractice && errors.FarmingPractice}
                                                disabled={factoryType == 1 || factoryType == 3 || allDisableButton}
                                            >
                                                <MenuItem key={0} value={0}> Select Farming Practice</MenuItem>
                                                <MenuItem value={1}> Conventional</MenuItem>
                                                <MenuItem value={2}> Gap</MenuItem>
                                                <MenuItem value={3}> Bee Safe</MenuItem>
                                                <MenuItem value={4}> Organic</MenuItem>
                                                <MenuItem value={5}> Other</MenuItem>
                                            </TextField>
                                        </Stack>
                                        <Stack width={340}>

                                            <TextField
                                                fullWidth
                                                size="small"
                                                label="Other Farming Practice *"
                                                value={formik.values.OtherFarmingPractice}
                                                onChange={formik.handleChange}
                                                {...getFieldProps('OtherFarmingPractice')}
                                                error={Boolean(touched.OtherFarmingPractice && errors.OtherFarmingPractice)}
                                                helperText={touched.OtherFarmingPractice && errors.OtherFarmingPractice}
                                                disabled={factoryType == 1 || factoryType == 3 || formik.values.FarmingPractice !== 5 || allDisableButton}
                                            />

                                        </Stack>
                                        <Stack width={340}>
                                            <TextField select
                                                fullWidth
                                                size="small"
                                                label="Farming System * "
                                                value={formik.values.FarmingSystem}
                                                onChange={formik.handleChange}
                                                {...getFieldProps('FarmingSystem')}
                                                error={Boolean(touched.FarmingSystem && errors.FarmingSystem)}
                                                helperText={touched.FarmingSystem && errors.FarmingSystem}
                                                disabled={factoryType == 1 || factoryType == 3 || allDisableButton}
                                            >
                                                <MenuItem key={0} value={0}> Select Farming System</MenuItem>
                                                <MenuItem value={1}> Modernized</MenuItem>
                                                <MenuItem value={2}> Not Modernized</MenuItem>
                                            </TextField>
                                        </Stack>
                                    </Stack>
                                    <Stack direction={{ xs: 'column', sm: 'row' }} style={{ marginTop: '25px' }} spacing={2}>
                                        <Stack width={340}>
                                            <TextField select
                                                fullWidth
                                                size="small"
                                                label="Technologies Used * "
                                                value={formik.values.TeachnologyUsed}
                                                onChange={(event) => {
                                                    formik.handleChange(event);

                                                    // Check if the selected value is 'Other' to enable/disable the other text field
                                                    if (event.target.value === 4) {
                                                        formik.setFieldValue('OtherTeachnologyUsed', '');
                                                    }
                                                }}
                                                {...getFieldProps('TeachnologyUsed')}
                                                error={Boolean(touched.TeachnologyUsed && errors.TeachnologyUsed)}
                                                helperText={touched.TeachnologyUsed && errors.TeachnologyUsed}
                                                disabled={factoryType == 1 || factoryType == 3 || allDisableButton}
                                            >
                                                <MenuItem key={0} value={0}> Select Technologies Used</MenuItem>
                                                <MenuItem value={1}> Irrigation</MenuItem>
                                                <MenuItem value={2}> Fertigation</MenuItem>
                                                <MenuItem value={3}> Sensors</MenuItem>
                                                <MenuItem value={4}> Other</MenuItem>
                                            </TextField>
                                        </Stack>
                                        <Stack width={340}>

                                            <TextField
                                                fullWidth
                                                size="small"
                                                label="Other Technologies Used *"
                                                value={formik.values.OtherTeachnologyUsed}
                                                onChange={formik.handleChange}
                                                {...getFieldProps('OtherTeachnologyUsed')}
                                                error={Boolean(touched.OtherTeachnologyUsed && errors.OtherTeachnologyUsed)}
                                                helperText={touched.OtherTeachnologyUsed && errors.OtherTeachnologyUsed}
                                                disabled={factoryType == 1 || factoryType == 3 || formik.values.TeachnologyUsed !== 4 || allDisableButton}
                                            />

                                        </Stack>
                                        <Stack width={340}>
                                            <TextField
                                                fullWidth
                                                id="outlined-name"
                                                size="small"
                                                type="date"
                                                label="Date Of First Installation"
                                                value={formik.values.DateOfFirstInstallation}
                                                onChange={formik.handleChange}
                                                {...getFieldProps('DateOfFirstInstallation')}
                                                InputLabelProps={{ shrink: true }}
                                                error={Boolean(touched.DateOfFirstInstallation && errors.DateOfFirstInstallation)}
                                                helperText={touched.DateOfFirstInstallation && errors.DateOfFirstInstallation}
                                                disabled={factoryType == 1 || factoryType == 3 || allDisableButton}
                                                inputProps={{
                                                    max: new Date().toISOString().split('T')[0],
                                                }}
                                            />
                                        </Stack>

                                    </Stack>
                                    <Stack direction={{ xs: 'column', sm: 'row' }} style={{ marginTop: '25px' }} spacing={2}>
                                        <Stack width={340}>
                                            <TextField select
                                                fullWidth
                                                size="small"
                                                label="Field Irrigation Method * "
                                                value={formik.values.FieldIrrigationMethod}
                                                onChange={(event) => {
                                                    formik.handleChange(event);

                                                    // Check if the selected value is 'Other' to enable/disable the other text field
                                                    if (event.target.value === 4) {
                                                        formik.setFieldValue('OtherFieldIrrigationMethod', '');
                                                    }
                                                }}
                                                {...getFieldProps('FieldIrrigationMethod')}
                                                error={Boolean(touched.FieldIrrigationMethod && errors.FieldIrrigationMethod)}
                                                helperText={touched.FieldIrrigationMethod && errors.FieldIrrigationMethod}
                                                disabled={factoryType == 1 || factoryType == 3 || allDisableButton}
                                            >
                                                <MenuItem key={0} value={0}> Select Field Irrigation Method</MenuItem>
                                                <MenuItem value={1}> Drip</MenuItem>
                                                <MenuItem value={2}> Sprinkler</MenuItem>
                                                <MenuItem value={3}> Flood</MenuItem>
                                                <MenuItem value={4}> Other</MenuItem>
                                            </TextField>
                                        </Stack>
                                        <Stack width={340}>

                                            <TextField
                                                fullWidth
                                                size="small"
                                                label="Other Field Irrigation Method *"
                                                value={formik.values.OtherFieldIrrigationMethod}
                                                onChange={formik.handleChange}
                                                {...getFieldProps('OtherFieldIrrigationMethod')}
                                                error={Boolean(touched.OtherFieldIrrigationMethod && errors.OtherFieldIrrigationMethod)}
                                                helperText={touched.OtherFieldIrrigationMethod && errors.OtherFieldIrrigationMethod}
                                                disabled={factoryType == 1 || factoryType == 3 || formik.values.FieldIrrigationMethod !== 4 || allDisableButton}
                                            />

                                        </Stack>
                                        <Stack width={340}>
                                            <TextField select
                                                fullWidth
                                                size="small"
                                                label="Water Source * "
                                                value={formik.values.WaterSource}
                                                onChange={(event) => {
                                                    formik.handleChange(event);

                                                    // Check if the selected value is 'Other' to enable/disable the other text field
                                                    if (event.target.value === 4) {
                                                        formik.setFieldValue('OtherWaterSource', '');
                                                    }
                                                }}
                                                {...getFieldProps('WaterSource')}
                                                error={Boolean(touched.WaterSource && errors.WaterSource)}
                                                helperText={touched.WaterSource && errors.WaterSource}
                                                disabled={factoryType == 1 || factoryType == 3 || allDisableButton}
                                            >
                                                <MenuItem key={0} value={0}> Select Water Source</MenuItem>
                                                <MenuItem value={1}> Agro-Well</MenuItem>
                                                <MenuItem value={2}> Deep-Well</MenuItem>
                                                <MenuItem value={3}> Canal Water</MenuItem>
                                                <MenuItem value={4}> Other</MenuItem>
                                            </TextField>
                                        </Stack>
                                    </Stack>
                                    <Stack direction={{ xs: 'column', sm: 'row' }} style={{ marginTop: '25px' }} spacing={2}>
                                        <Stack width={340}>
                                            <TextField
                                                fullWidth
                                                size="small"
                                                label="Other Water Source *"
                                                value={formik.values.OtherWaterSource}
                                                onChange={formik.handleChange}
                                                {...getFieldProps('OtherWaterSource')}
                                                error={Boolean(touched.OtherWaterSource && errors.OtherWaterSource)}
                                                helperText={touched.OtherWaterSource && errors.OtherWaterSource}
                                                disabled={factoryType == 1 || factoryType == 3 || formik.values.WaterSource !== 4 || allDisableButton}
                                            />
                                        </Stack>
                                    </Stack>
                                    {/* <Stack direction={{ xs: 'column', sm: 'row' }} style={{ marginTop: '25px' }} spacing={2}>

                                        <Stack width={340}>
                                            <TextField select
                                                fullWidth
                                                size="small"
                                                label="Labour Used * "
                                                value={formik.values.LabourType}
                                                onChange={(event) => {
                                                    formik.handleChange(event);

                                                    // Check if the selected value is 'Other' to enable/disable the other text field
                                                    if (event.target.value === 4) {
                                                        formik.setFieldValue('OtherLabourType', '');
                                                    }
                                                }}
                                                {...getFieldProps('LabourType')}
                                                error={Boolean(touched.LabourType && errors.LabourType)}
                                                helperText={touched.LabourType && errors.LabourType}
                                                disabled={factoryType == 1 || factoryType == 3}
                                            >
                                                <MenuItem key={0} value={0}> Select Labour Used</MenuItem>
                                                <MenuItem value={1}> Family</MenuItem>
                                                <MenuItem value={2}> Hired-Permanent</MenuItem>
                                                <MenuItem value={3}> Hired-Casual</MenuItem>
                                                <MenuItem value={4}> Other</MenuItem>
                                            </TextField>
                                        </Stack>
                                        <Stack width={340}>

                                            <TextField
                                                fullWidth
                                                size="small"
                                                label="Other Labour Used *"
                                                value={formik.values.OtherLabourType}
                                                onChange={formik.handleChange}
                                                {...getFieldProps('OtherLabourType')}
                                                error={Boolean(touched.OtherLabourType && errors.OtherLabourType)}
                                                helperText={touched.OtherLabourType && errors.OtherLabourType}
                                                disabled={factoryType == 1 || factoryType == 3 || formik.values.LabourType !== 4}
                                            />

                                        </Stack> */}
                                    {/* <Stack width={340}>
                                            <TextField select
                                                fullWidth
                                                size="small"
                                                label="Farming Master Type *"
                                                value={formik.values.farmingMasterID}
                                                onChange={formik.handleChange}
                                                {...getFieldProps('farmingMasterID')}
                                                error={Boolean(touched.farmingMasterID && errors.farmingMasterID)}
                                                helperText={touched.farmingMasterID && errors.farmingMasterID}
                                                disabled={factoryType == 1 || factoryType == 3}
                                            >
                                                <MenuItem key={0} value={0}> Select Farming Master Type</MenuItem>
                                                {farmingMaster.map((option) => (
                                                    <MenuItem key={option.farmingMasterID} value={option.farmingMasterID}>
                                                        {option.farmingMasterName}
                                                    </MenuItem>
                                                ))}
                                            </TextField>
                                        </Stack> 
                                    </Stack> */}
                                    {/* <Stack direction={{ xs: 'column', sm: 'row' }} style={{ marginTop: '25px' }} spacing={2}>

                                        <Stack width={340}>
                                            <TextField
                                                select
                                                fullWidth
                                                size="small"
                                                label="Farming Sub Type *"
                                                value={formik.values.farmingChildID}
                                                onChange={(e) => {
                                                    const selectedValue = e.target.value;
                                                    const selectedFarmingChild = farmingChild.find(
                                                        (option) => option.farmingChildID === selectedValue
                                                    );

                                                    formik.setValues({
                                                        ...formik.values,
                                                        farmingChildID: selectedValue,
                                                        farmingChildName: selectedFarmingChild ? selectedFarmingChild.farmingChildName : '',
                                                    });
                                                }}
                                                error={Boolean(touched.farmingChildID && errors.farmingChildID)}
                                                helperText={touched.farmingChildID && errors.farmingChildID}
                                                disabled={factoryType === 1 || factoryType === 3}
                                            >
                                                <MenuItem key={0} value={0}>
                                                    Select Farming Sub Type
                                                </MenuItem>
                                                {farmingChild.map((option) => (
                                                    <MenuItem key={option.farmingChildID} value={option.farmingChildID}>
                                                        {option.farmingChildName}
                                                    </MenuItem>
                                                ))}
                                            </TextField>

                                        </Stack>

                                        <Stack width={340}>
                                            {enableOther == true ?

                                                <TextField
                                                    fullWidth
                                                    size="small"
                                                    label="Other *"
                                                    value={formik.values.other}
                                                    onChange={formik.handleChange}
                                                    {...getFieldProps('other')}
                                                    error={Boolean(touched.other && errors.other)}
                                                    helperText={touched.other && errors.other}
                                                    disabled={factoryType == 1 || factoryType == 3}
                                                />
                                                : null}
                                        </Stack>
                                    </Stack> */}
                                    <Stack direction={{ xs: 'column', sm: 'row' }} justifyContent="right" spacing={2}>
                                        <LoadingButton
                                            size="medium"
                                            type="button"
                                            variant="outlined"
                                            color='error'
                                            onClick={() => clearAll()}
                                            disabled={pageProps.Edit || factoryType == 1 || factoryType == 3 || allDisableButton}
                                        >
                                            Clear
                                        </LoadingButton>
                                        <LoadingButton
                                            size="medium"
                                            type="submit"
                                            variant="outlined"
                                            color='secondary'
                                            disabled={factoryType == 1 || factoryType == 3 || allDisableButton}
                                        >
                                            {pageProps.submitButtonName}
                                        </LoadingButton>
                                    </Stack>

                                    <Divider variant="middle" />
                                    {(dataGrid.length > 0) ?
                                        <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                                            <Card style={{ justifycontent: 'center', width: '65rem' }} >
                                                <TableContainer component={Paper} >
                                                    <Table aria-label="caption table">
                                                        <TableHead>
                                                            <TableRow>
                                                                <TableCell align="center">Crops Cultivated</TableCell>
                                                                <TableCell align="center">Field Type</TableCell>
                                                                <TableCell align="center">Cultivatable Land Extent</TableCell>
                                                                <TableCell align="center">Value</TableCell>
                                                                <TableCell align="center">Farming Practice</TableCell>
                                                                <TableCell align="center">Farming System</TableCell>
                                                                <TableCell align="center">Technologies Used</TableCell>
                                                                <TableCell align="center">Field Irrigation Method</TableCell>
                                                                <TableCell align="center">Water Source</TableCell>
                                                                {(factoryType == 1 || factoryType == 3) ? null :
                                                                    <TableCell align="center">Action</TableCell>}
                                                            </TableRow>
                                                        </TableHead>
                                                        <TableBody>
                                                            {dataGrid.map((rowData, index) => (
                                                                <TableRow key={index}>
                                                                    <TableCell align="center" component="th" scope="row" style={{ borderBottom: "none" }}>
                                                                        {rowData.typesOfCrops == 1
                                                                            ? 'Vegetable'
                                                                            : rowData.typesOfCrops == 2
                                                                                ? 'Fruits'
                                                                                : rowData.typesOfCrops == 3
                                                                                    ? 'Paddy'
                                                                                    : rowData.otherTypesOfCrops
                                                                        }
                                                                    </TableCell>

                                                                    <TableCell align="center" component="th" scope="row" style={{ borderBottom: "none" }}>
                                                                        {rowData.typesOfField == 1
                                                                            ? 'Open Field'
                                                                            : rowData.typesOfField == 2
                                                                                ? 'Poly Tunnel'
                                                                                : rowData.otherTypesOfField
                                                                        }
                                                                    </TableCell>

                                                                    <TableCell align="center" component="th" scope="row" style={{ borderBottom: "none" }}>
                                                                        {rowData.cultivateLandExtent == 1
                                                                            ? 'Acres'
                                                                            : rowData.cultivateLandExtent == 2
                                                                                ? 'Perches'
                                                                                : rowData.cultivateLandExtent == 3
                                                                                    ? 'Sq.ft'
                                                                                    : " "
                                                                        }
                                                                    </TableCell>

                                                                    <TableCell align="center" component="th" scope="row" style={{ borderBottom: "none" }}>
                                                                        {parseFloat(rowData.value).toFixed(2)}
                                                                    </TableCell>

                                                                    <TableCell align="center" component="th" scope="row" style={{ borderBottom: "none" }}>
                                                                        {rowData.farmingPractice == 1
                                                                            ? 'Conventional'
                                                                            : rowData.farmingPractice == 2
                                                                                ? 'Gap'
                                                                                : rowData.farmingPractice == 3
                                                                                    ? 'Bee Safe'
                                                                                    : rowData.farmingPractice == 4
                                                                                        ? 'Organic'
                                                                                        : rowData.otherFarmingPractice
                                                                        }
                                                                    </TableCell>
                                                                    <TableCell align="center" component="th" scope="row" style={{ borderBottom: "none" }}>
                                                                        {rowData.farmingSystem == 1
                                                                            ? 'Modernized'
                                                                            : rowData.farmingSystem == 2
                                                                                ? 'Not-Modernized'
                                                                                : ''
                                                                        }
                                                                    </TableCell>

                                                                    <TableCell align="center" component="th" scope="row" style={{ borderBottom: "none" }}>
                                                                        {rowData.teachnologyUsed == 1
                                                                            ? 'Irrigation'
                                                                            : rowData.teachnologyUsed == 2
                                                                                ? 'Fertigation'
                                                                                : rowData.teachnologyUsed == 3
                                                                                    ? 'Sensors'
                                                                                    : rowData.otherTeachnologyUsed
                                                                        }
                                                                    </TableCell>
                                                                    <TableCell align="center" component="th" scope="row" style={{ borderBottom: "none" }}>
                                                                        {rowData.fieldIrrigationMethod == 1
                                                                            ? 'Drip'
                                                                            : rowData.fieldIrrigationMethod == 2
                                                                                ? 'Sprinkler'
                                                                                : rowData.fieldIrrigationMethod == 3
                                                                                    ? 'Flood'
                                                                                    : rowData.otherFieldIrrigationMethod
                                                                        }
                                                                    </TableCell>
                                                                    <TableCell align="center" component="th" scope="row" style={{ borderBottom: "none" }}>
                                                                        {rowData.waterSource == 1
                                                                            ? 'Agro-Well'
                                                                            : rowData.waterSource == 2
                                                                                ? 'Deep-Well'
                                                                                : rowData.waterSource == 3
                                                                                    ? 'Canal Water'
                                                                                    : rowData.otherWaterSource
                                                                        }
                                                                    </TableCell>
                                                                    {(factoryType == 1 || factoryType == 3) ? null : (
                                                                        <TableCell align="center" component="th" scope="row" style={{ borderBottom: "none" }}>
                                                                            {pageProps.Edit != true ?
                                                                                <Tooltip title="Edit">
                                                                                    <IconButton
                                                                                        variant="outlined"
                                                                                        onClick={() => handleEdit(rowData, index)}>
                                                                                        <EditIcon />
                                                                                    </IconButton>
                                                                                </Tooltip> : null}
                                                                            <Tooltip title="Delete">
                                                                                <IconButton
                                                                                    variant="outlined"
                                                                                    color="error"
                                                                                    onClick={(e) => handleConfirm(rowData.farmerFarmingDetailID)}
                                                                                >
                                                                                    <DeleteIcon />
                                                                                </IconButton>
                                                                            </Tooltip>
                                                                        </TableCell>
                                                                    )}
                                                                </TableRow>

                                                            ))}
                                                        </TableBody>
                                                    </Table>
                                                </TableContainer>
                                            </Card>
                                        </Stack> : null}
                                </Stack>
                            </Card>
                        </Form>
                    </FormikProvider>
                </Container>
                <div hidden={true}>
                    <Grid item>
                        <AlertDialog confirmData={confirmData} headerMessage={message} viewPopup={EnableConfirmMessage}
                            discription={"Are you sure want to delete farming details ?"} setViewPopup={setEnableConfirmMessage} />
                    </Grid>
                </div>
            </Page >
        </>
    )
} 